import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {List, Dropdown, Label, Modal, Button} from 'semantic-ui-react'
import {Link} from 'react-router-dom'
import PDFDisplay from '../../utils/DisplayPDF'
import {api} from '../../../api'

const options = [
    { key: 'shipment', text: 'Packing Slip', value: 'shipment' },
    { key: 'invoice', text: 'Invoice', value: 'invoice' }
]

class ShipmentSegment extends Component {
    constructor() {
        super();
        this.state = {
            pdfViewer: false,
            base64String: ""
        }
    }

    onPdfModalClose = () => {
        this.setState({
            pdfViewer: false
        });
    }

    getShipmentRouting = (id) => {
        const {orderType} = this.props;
        if (orderType === 'Customer Order' || orderType === 'Vendor Return') {
            return `/shipments/shipping/${id}/view`
        }
        if (orderType === 'Vendor Order' || orderType === 'Customer Return') {
            return `/shipments/receiving/${id}/view`
        }
        return '/'
    }

    _onPrintOptionSelected = (value, shipment) => {
        const params = {
            docType: value,
            docId: shipment.id
        };
        api.pdf(this.props.jwt, params).then(res => {
            const {data} = res.data;
            this.setState({
                pdfViewer: true,
                base64String: data
            });
        })
    }

    getWarehouseName = (shipment) => {
        const {warehouse_id} = shipment;
        const {warehouses} = this.props;
        const warehouse = warehouses.filter(i => {
            return i.value === _.toString(warehouse_id);
        });
        if (warehouse.length > 0) {
            return warehouse[0].text;
        }
        return "";
    }
    
    render() {
        return (
            <div>
                <List divided verticalAlign='middle'>
                    {this.props.shipments.map((shipment, index) => {
                        return (
                            <List.Item key={shipment.id}>
                                <List.Content floated='right'>
                                    <div style={{paddingTop: '10px'}}>
                                        <Dropdown  
                                            onChange={(e, {value}) => {this._onPrintOptionSelected(value, shipment)}}
                                            floating options={options} direction='left' text='Print'/>
                                    </div>
                                </List.Content>
                                <List.Content>
                                    <div style={{paddingTop: '3px', paddingBottom: '3px'}}>
                                        <Link to={this.getShipmentRouting(shipment.id)}>
                                            <h4>Shipment # {index+1}</h4>
                                        </Link>
                                        {shipment.status === 'Pending' ? <Label color='teal' size='mini'>Pending</Label> : null}
                                        {shipment.status === 'Shipped' ? <Label color='green' size='mini'>Completed</Label> : null}
                                        <Label color='orange' size='mini'>{this.getWarehouseName(shipment)}</Label>
                                    </div>
                                </List.Content>
                            </List.Item>
                        )
                    })}
                </List>
                <Modal size='large' open={this.state.pdfViewer} onClose={this.onPdfModalClose} closeOnDimmerClick={false}>
                    <Modal.Content>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-md-12">
                                <Button size='mini' color='teal' floated='right' onClick={() => {this.onPdfModalClose()}}>Close</Button>
                            </div>
                        </div>
                        <PDFDisplay pdf={this.state.base64String} />
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}

ShipmentSegment.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    jwt: PropTypes.string.isRequired,
    shipments: PropTypes.array.isRequired,
    orderType: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired
};

export default ShipmentSegment


// WEBPACK FOOTER //
// ./src/components/orders/parts/ShipmentSegment.js